import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, FormDashboardInput as Input } from "../../../components";
import { fetchAccount } from "../../../features/account/slice";
import apiService from "../../../features/api/service";
import { fetchIndividu } from "../../../features/individu/slice";
import { fetchOrganization } from "../../../features/organization/slice";
import { errorHandler } from "../../../utils";
import khub from "../../../database/khub.json";
import { useInternationalization } from "../../../features/i18n";
const { email: EMAIL, whatsapp: WHATSAPP, whatsapp_link } = khub;

const label = {
  send: {
    en: "Send verification code to my email",
    id: 'Kirim kode verifikasi ke surel saya'
  },
  sending: {
    en: "Sending verification code...",
    id: 'Mengirim kode verifikasi...'
  },
  verify: {
    en: 'Verify My Account',
    id: 'Verifikasi Akun Saya'
  },
  otpPlaceholder: {
    en: 'OTP code from email',
    id: 'Kode OTP dari email'
  },
  success: {
    en: 'OTP code sent successfully! Please check your email inbox.',
    id: 'Kode OTP berhasil dikirim! Mohon periksa kotak masuk surel Anda.'
  }
}

const verifiedMessage = {
  id: "Akun Anda sudah terverifikasi.",
  en: "Your account has been verified.",
};

const ContentVerification = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = React.useState(false);
  const [requesting, setRequesting] = React.useState(false);
  const [otpCode, setOtpCode] = React.useState("");
  const { email } = useSelector((state) => state.account.data);
  const { isIndividu, isVerified } = useSelector((state) => state.account);
  const myId = useSelector((state) => state.account.profile.id);
  const { language, translate } = useInternationalization();
  const [message, setMessage] = React.useState(null);

  const verify = () => {
    if (otpCode) {
      const requestBody = {
        otp: otpCode,
        requestVerificatedUser: 1,
      };

      setRequesting(true);

      apiService
        .create("account_verify", requestBody)
        .then((res) => {
          toast.success("Verification success!");
          dispatch(fetchAccount());
          if (isIndividu) {
            dispatch(fetchIndividu(myId));
          } else {
            dispatch(fetchOrganization(myId));
          }
          setShowForm(false);

          if (res.message) {
            setMessage(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("Verification failed.");
        })
        .finally(() => {
          setRequesting(false);
        });
    }
  };

  const requestOTP = () => {
    if (email) {
      const confirmMessage = language.name === 'en' ? `We will send an OTP code to this email address: ${email}\nAre you sure?`
        : `Kami akan mengirim kode OTP ke alamat email berikut ini: ${email}\nAnda yakin?`
      let c = window.confirm(confirmMessage);
      if (c) {
        const requestBody = {
          email: email,
          method: 1,
        };

        setRequesting(true);

        apiService
          .create("otp_verification", requestBody)
          .then((res) => {
            alert(label.success[language.name]);
            setShowForm(true);
          })
          .catch((err) => {
            const msg = errorHandler(err);
            toast.error(msg);
          })
          .finally(() => setRequesting(false));
      }
    }
  };

  return (
    <div className="w-full">
      <p className="text-lg font-bold mb-4">
        {translate("GENERAL", "account_verification")}
      </p>
      {isVerified ? (
        <p className="text-sm">{verifiedMessage[language.name]}</p>
      ) : (
        <p className="text-sm text-gray-444 mb-5 lg:mb-8">
          {language.name === "id" ? (
            <>
              Demi keamanan selama menggunakan platform, proses verifikasi akan
              melalui 2 tahap, yaitu: <strong>Verifikasi Email</strong> dan{" "}
              <strong>Verifikasi Manual</strong> oleh Admin (diproses setiap
              pukul 10.00 a.m). Jika setelah verifikasi email berhasil dan belum
              menjadi <strong>Verified User</strong>, harap menghubungi admin
              melalui{" "}
              <a
                className="text-primary underline mr-1"
                href={
                  whatsapp_link ? whatsapp_link : `https://wa.me/${WHATSAPP}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <em>WhatsApp</em>
              </a>{" "}
              atau{" "}
              <a className="text-primary underline" href={`mailto:${EMAIL}`}>
                <em>email</em>
              </a>
              .
            </>
          ) : (
            <>
              For the sake of security while using the platform, the
              verification process will go through 2 stages, namely:{" "}
              <strong>Email Verification</strong> and{" "}
              <strong>Manual Verification</strong> by the Admin (processed every
              10.00 am). If after the email verification is successful and has
              not become a <strong>Verified User</strong>, please contact the
              admin via{" "}
              <a
                className="text-primary underline mr-1"
                href={
                  whatsapp_link ? whatsapp_link : `https://wa.me/${WHATSAPP}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <em>WhatsApp</em>
              </a>{" "}
              or{" "}
              <a className="text-primary underline" href={`mailto:${EMAIL}`}>
                email
              </a>
              .
            </>
          )}
        </p>
      )}
      {message !== null && <p className="text-sm mb-4">{message}</p>}
      {!isVerified && (
        <>
          {showForm ? (
            <div className="flex w-full md:w-2/3 lg:w-1/2">
              <Input
                className="w-full"
                placeholder={label.otpPlaceholder[language.name]}
                onChange={(e) => setOtpCode(e.target.value)}
              />
              <Button
                className="ml-2 w-auto"
                thin
                onClick={verify}
                disabled={requesting}
                isLoading={requesting}
              >
                {label.verify[language.name]}
              </Button>
            </div>
          ) : (
            <p className="link text-sm inline-block" onClick={() => requestOTP()}>
              {requesting
                ? label.sending[language.name]
                : label.send[language.name]
              }
            </p>
          )}
        </>
      )}
    </div>
  );
};

export { ContentVerification };
